import { Provider, lightTheme } from '@adobe/react-spectrum';
import { ReactNode, useEffect } from 'react';
import '@spectrum-css/vars/dist/spectrum-global.css';
import '@spectrum-css/vars/dist/spectrum-medium.css';
import '@spectrum-css/vars/dist/spectrum-light.css';
import '@spectrum-css/vars/dist/spectrum-dark.css';
import '@spectrum-css/closebutton/dist/index-vars.css';
import '@spectrum-css/sidenav/dist/index-vars.css';
import '@spectrum-css/toast/dist/index-vars.css';

interface DesignProviderProps {
  children: ReactNode;
}

export const DesignProvider = (props: DesignProviderProps) => {
  useEffect(() => {
    document.documentElement.classList.add('spectrum');
    document.documentElement.classList.add('spectrum--medium');
    document.documentElement.classList.add('spectrum--light');
    document.documentElement.classList.add('spectrum--dark');
  }, []);
  return <Provider theme={lightTheme} {...props} />;
};
